import { useState, useEffect } from 'react';

const TableOfContents = ({ sections }) => {

    const [activeSection, setActiveSection] = useState('section-0');

    const headings = sections
        .filter(section => section.type === 'text' && (section.heading || section.subheading))
        .map((section, index) => ({
            id: `section-${index}`,
            title: section.heading || section.subheading,
            isSubheading: !section.heading && section.subheading
        }));

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            {
                rootMargin: '-10% 0px -70% 0px',
                threshold: 0
            }
        );

        headings.forEach(({ id }) => {
            const element = document.getElementById(id);
            if (element) {
                observer.observe(element);
            }
        });

        return () => {
            headings.forEach(({ id }) => {
                const element = document.getElementById(id);
                if (element) {
                    observer.unobserve(element);
                }
            });
        };
    }, [headings]);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const offset = 100;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    if (headings.length === 0) {
        return null;
    }

    return (
        <nav className="hidden lg:block sticky top-24 self-start max-h-[calc(100vh-8rem)] overflow-y-auto">
            <div className="pr-8">
                <h2 className="text-xs font-bold uppercase tracking-widest text-off-white mb-4 opacity-75">
                    On This Page
                </h2>
                <ul className="space-y-2 border-l-2 border-slate-200/10">
                    {headings.map(({ id, title, isSubheading }) => (
                        <li key={id}>
                            <button
                                onClick={() => scrollToSection(id)}
                                className={`
                                    block w-full text-left pr-2 py-1 text-sm transition-all duration-200
                                    border-l-2 -ml-[2px]
                                    ${isSubheading ? 'pl-8' : 'pl-4'}
                                    ${activeSection === id
                                        ? 'border-cherry-blossom text-cherry-blossom font-semibold'
                                        : 'border-transparent text-off-white opacity-60 hover:opacity-100 hover:border-slate-200/50'
                                    }
                                `}
                            >
                                {title}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
};

export default TableOfContents;